import AdminAiScanReview from "../components/ai-scans/AdminAiScanReview";
import { useAdminAiScanReports } from "../hooks/useAdminAiScanReports";

// Reads access-control reports only while this page is mounted.
// Keeps boundary findings and their remediation references beside the original review depth.
// A green finding or an empty finding list does not replace the report's coverage assessment.
const AdminAiAcScanPage = () => {
  const { reports, featureReports, issues, loading, error, refresh, available } = useAdminAiScanReports("ac");

  return (
    <AdminAiScanReview
      scan="ac"
      title="Access Control"
      description="Review roles, ownership, privacy and backend permission boundaries by feature. Follow each missing control to its affected route, resource and linked remediation. Original color and score notation remain visible; reviewed, weak and unreviewed coverage are separate from finding severity."
      featureReviewKey="boReview"
      findingFields={[
        "summary",
        "detail",
        "resourceBoundary",
        "routeMethod",
        "missingControl",
        "downstreamCommand",
        "affectedFeatureIds",
        "affectedEndpointIds",
        "remediationIds",
        "canonicalKey",
      ]}
      reports={reports}
      featureReports={featureReports}
      issues={issues}
      loading={loading}
      error={error}
      available={available}
      onRefresh={refresh}
    />
  );
};

export default AdminAiAcScanPage;
